import * as React from "react"

export const Slash = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M11.413 18.054a.97.97 0 0 1-.462.614.97.97 0 0 1-.763.094.97.97 0 0 1-.614-.463.97.97 0 0 1-.093-.762l3.106-11.591a.97.97 0 0 1 .462-.614.97.97 0 0 1 .763-.093.97.97 0 0 1 .614.462.97.97 0 0 1 .093.762z" />
  </svg>
)
